'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrowser = exports.hasDocument = exports.hasWindow = exports.propertyFilter = exports.styleReducer = exports.hashed = exports.randomHex = exports.isStyleProp = exports.kebab = exports.parseValue = exports.isObjectAndNotArray = exports.isArrayOrNotObject = exports.isArr = exports.isObj = exports.isNotSelector = exports.isMediaQuery = exports.isPseudoSelector = exports.isAnimation = exports.isNested = exports.exists = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _addPxToStyle = require('add-px-to-style');

var _addPxToStyle2 = _interopRequireDefault(_addPxToStyle);

var _murmurhash3_gc = require('murmurhash-js/murmurhash3_gc');

var _murmurhash3_gc2 = _interopRequireDefault(_murmurhash3_gc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var floor = Math.floor;
var random = Math.random;
var exists = exports.exists = function exists(v) {
  return v !== null && typeof v !== 'undefined';
};
var isNested = exports.isNested = function isNested() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (/\s|:|^@|^\d|^from$|^to$/.test(key)
  );
};
var isAnimation = exports.isAnimation = function isAnimation() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return key[0] === '@' && key[1] === 'k';
};
var isPseudoSelector = exports.isPseudoSelector = function isPseudoSelector() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return key[0] === ':';
};
var isMediaQuery = exports.isMediaQuery = function isMediaQuery() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return key[0] === '@';
};
var isNotSelector = exports.isNotSelector = function isNotSelector() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (/^([0-9]|from|to)/.test(key)
  );
};
var isObj = exports.isObj = function isObj(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object';
};
var isArr = exports.isArr = function isArr(v) {
  return Array.isArray(v);
};
var isArrayOrNotObject = exports.isArrayOrNotObject = function isArrayOrNotObject(v) {
  return exists(v) && (isArr(v) || !isObj(v));
};
var isObjectAndNotArray = exports.isObjectAndNotArray = function isObjectAndNotArray(v) {
  return exists(v) && !isArr(v) && isObj(v);
};
var parseValue = exports.parseValue = function parseValue(prop, val) {
  return typeof val === 'number' ? (0, _addPxToStyle2.default)(prop, val) : val;
};
var kebab = exports.kebab = function kebab(key) {
  return key.replace(/([A-Z]|^ms|^webkit)/g, function (g) {
    return '-' + g.toLowerCase();
  });
};
var isStyleProp = exports.isStyleProp = function isStyleProp(key) {
  return !isNested(key);
};
var randomHex = exports.randomHex = function randomHex() {
  return floor(random() * 16777215).toString(16);
};
var hashed = exports.hashed = function hashed(str) {
  return 'cxsync-' + (0, _murmurhash3_gc2.default)(str, 128);
};
var styleReducer = exports.styleReducer = function styleReducer(a, b) {
  return a.indexOf(b) > -1 ? a : [].concat(_toConsumableArray(a), [b]);
};
var propertyFilter = exports.propertyFilter = function propertyFilter(_ref) {
  var selector = _ref.selector;
  return !/:/.test(selector) && !/\s/.test(selector);
};
var hasWindow = exports.hasWindow = function hasWindow() {
  return typeof window !== 'undefined';
};
var hasDocument = exports.hasDocument = function hasDocument() {
  return typeof document !== 'undefined';
};
var isBrowser = exports.isBrowser = function () {
  return hasWindow() && hasDocument() && document.nodeType === 9;
}();